// import { ErrorsDisplay } from 'components/ErrorsDisplay'
import { useForm } from 'hooks/useForm'
import React, { FC, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { triggerPasswordReset } from 'state/async_actions'
import { useAppContext } from 'state/context'

export const PasswordResetEmailForm: FC<{ initialTriggerState?: boolean }> = ({
  initialTriggerState = false,
}) => {
  const [, dispatch] = useAppContext()
  const [triggered, setTriggered] = useState(initialTriggerState)

  const [inputs, handleInputChange, handleSubmit, validated] = useForm<{
    email: string
  }>(({ email }) =>
    triggerPasswordReset(dispatch, email, () => setTriggered(true)),
  )

  const form = (
    <>
      <Row>
        <Col>
          <h1>Reset your password</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Please enter your email below. If we have it in our records, we will
            send you an email with instructions on how to reset your password.
          </p>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange as any}
                value={inputs.email || ''}
                name="email"
                type="email"
                placeholder="Enter email"
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid email address.
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" value="SUBMIT" type="submit">
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )

  const triggeredMessage = (
    <>
      <Row>
        <Col>
          <h1>Thank You!</h1>
          <p>
            If your email is in our records, we will send you an email with
            instructions on how to reset your password.
          </p>
        </Col>
      </Row>
    </>
  )

  return triggered ? triggeredMessage : form
}
